module.exports = __webpack_public_path__ + "static/media/tag-w-blue-bground-icon.a5e3116b.svg";